import { FieldHelperProps, FieldInputProps } from 'formik'
import React from 'react'

export const trimFieldOnBlur =
  <T extends HTMLInputElement | HTMLTextAreaElement>(
    field: FieldInputProps<string>,
    helpers: FieldHelperProps<string>
  ) =>
  (event: React.FocusEvent<T>): void => {
    const trimmed = event.target.value.trim()
    if (trimmed !== event.target.value) void helpers.setValue(trimmed, true)

    field.onBlur(event)
  }
